module.exports = __webpack_public_path__ + "static/media/08.3e7ae92c.png";